<div class="notifications-wrapper relative">
  <p-button
    styleClass="p-button-text p-button-secondary border-circle w-3rem h-3rem"
    data-testid="notifications-trigger"
    [attr.aria-label]="unreadCount() > 0 ? 'Notificações, ' + unreadCount() + ' não lidas' : 'Notificações'"
    (click)="op.toggle($event)">
    <lucide-icon
      name="bell"
      size="20"
      class="flex align-items-center p-0 m-0"></lucide-icon>
  </p-button>

  @if (unreadCount() > 0) {
  <p-badge
    [value]="unreadCount().toString()"
    severity="danger"
    [style]="{ top: '-2px', right: '3px' }"
    styleClass="absolute notification-badge"></p-badge>
  }

  <p-popover
    #op
    appendTo="body"
    [style]="{ width: '24rem' }"
    styleClass="p-0 notifications-popover">
    <ng-template pTemplate="content">
      <div class="notifications-container">
        <header class="notifications-container__header">
          <div class="notifications-container__title">
            <h2 class="notifications-container__heading">Notificações</h2>
            @if (unreadCount() > 0) {
            <span class="notifications-container__count">{{ unreadCount() }} não lidas</span>
            }
          </div>
          @if (unreadCount() > 0) {
          <button
            type="button"
            class="notifications-container__link"
            data-testid="notifications-popover-mark-all"
            (click)="clearAll()">
            Marcar todas como lidas
          </button>
          }
        </header>

        <div class="notifications-list">
          @if (loading()) {
          <div class="notifications-container__loading" aria-label="Carregando notificações">
            @for (placeholder of [1, 2, 3]; track placeholder) {
            <div class="flex gap-3">
              <p-skeleton shape="circle" size="2rem" />
              <div class="flex-grow-1">
                <p-skeleton width="60%" height="0.8rem" styleClass="mb-2" />
                <p-skeleton width="90%" height="0.7rem" />
              </div>
            </div>
            }
          </div>
          } @else if (notifications().length === 0) {
          <div class="notifications-container__empty">
            <span class="notifications-container__empty-icon">
              <lucide-icon name="bell-off" [size]="20" aria-hidden="true"></lucide-icon>
            </span>
            <strong>Você está em dia</strong>
            <span>Quando algo precisar da sua atenção, aparece aqui.</span>
          </div>
          } @else {
          <ul class="notifications-container__items">
            @for (notification of notifications(); track notification.id) {
            <li
              class="notification-item"
              [class.notification-item--unread]="!notification.readAt">
              <button
                type="button"
                class="notification-item__button"
                (click)="handleNotificationClick(notification)">
                <span class="notification-item__tile" [ngClass]="getColorClass(notification)">
                  <lucide-icon [name]="getIcon(notification)" [size]="16" aria-hidden="true"></lucide-icon>
                </span>
                <span class="notification-item__content">
                  <span class="notification-item__head">
                    <span class="notification-item__title">{{ notification.title }}</span>
                    <span class="notification-item__time">{{ notification.createdAt | timeAgo }}</span>
                  </span>
                  <span class="notification-item__message">{{ notification.message }}</span>
                </span>
                @if (!notification.readAt) {
                <span class="notification-item__dot" role="img" aria-label="Não lida"></span>
                }
              </button>
            </li>
            }
          </ul>
          }
        </div>

        <footer class="notifications-container__footer">
          <button
            type="button"
            class="notifications-container__view-all"
            data-testid="notifications-view-all"
            (click)="viewAll()">
            Ver todas as notificações
            <lucide-icon name="arrow-right" [size]="14" aria-hidden="true"></lucide-icon>
          </button>
          <button
            type="button"
            class="notifications-container__preferences"
            data-testid="notifications-preferences"
            aria-label="Preferências de notificação"
            (click)="openPreferences()">
            <lucide-icon name="settings-2" [size]="16" aria-hidden="true"></lucide-icon>
          </button>
        </footer>
      </div>
    </ng-template>
  </p-popover>
</div>
